import apiClient from '../apiClient';

interface VerifyTokenValidityResponse {
	uid: string;
	email: string;
	token: string;
	is_onboarded: boolean;
	sign_in_provider: string;
	error?: string;
	status_code?: number;
}

export const verifyTokenValidity = async (token: string) => {
	try {
		const verifyTokenResponse: VerifyTokenValidityResponse = await apiClient('/auth/verify_token/', {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		if (verifyTokenResponse.error) {
			throw new Error(verifyTokenResponse.error);
		}

		return {
			uid: verifyTokenResponse.uid,
			email: verifyTokenResponse.email,
			token: verifyTokenResponse.token,
			isOnboarded: verifyTokenResponse.is_onboarded,
			signInProvider: verifyTokenResponse.sign_in_provider,
		};
	} catch (error: any) {
		console.debug('Token validation failed:', error.message);
	}
};
